import type { FC, ReactNode } from "react";

export interface StatItem {
  label: string;
  value: ReactNode;
  className?: string;
}

export interface StatsGridProps {
  items: StatItem[];
  columns?: 2 | 3 | 4;
  className?: string;
}

/**
 * StatsGrid Component
 *
 * Displays a grid of labeled statistics.
 *
 * @example
 * ```tsx
 * <StatsGrid
 *   items={[
 *     { label: 'Total', value: 10 },
 *     { label: 'Active', value: 5 },
 *   ]}
 * />
 * ```
 */
export const StatsGrid: FC<StatsGridProps> = ({
  items,
  columns = 2,
  className = "",
}) => {
  const gridCols = { 2: "grid-cols-2", 3: "grid-cols-3", 4: "grid-cols-4" };

  return (
    <div className={`grid gap-2 ${gridCols[columns]} ${className}`.trim()}>
      {items.map((item, index) => (
        <div key={index} className={`text-xs ${item.className ?? ""}`}>
          <p className="font-mono text-[10px] font-bold uppercase tracking-[0.16em] text-slate-500 dark:text-slate-400">
            {item.label}
          </p>
          <div className="text-slate-700 dark:text-slate-200">{item.value}</div>
        </div>
      ))}
    </div>
  );
};
